/* Simple persistent countdown timer
 * Element: .countdown-timer
 * Attributes:
 *  - data-minutes: starting minutes (default 10)
 *  - data-persist-key: localStorage key (default 'promo_countdown')
 * Behavior:
 *  - Persists remaining time in localStorage; resets when page has no saved value or saved is <=0
 */
(function(){
  const el = document.querySelector('.countdown-timer');
  if(!el) return;
  const minutes = parseInt(el.dataset.minutes || '10', 10);
  const persistOff = (el.dataset.persist === 'false' || el.dataset.persist === '0');
  const key = persistOff ? null : (el.dataset.persistKey || 'promo_countdown');
  const now = Date.now();

  function load(){
    if(!key) return null;
    try{
      const raw = localStorage.getItem(key);
      if(!raw) return null;
      const obj = JSON.parse(raw);
      return obj && typeof obj.until === 'number' ? obj : null;
    }catch(e){return null;}
  }
  function save(until){
    if(!key) return;
    try{ localStorage.setItem(key, JSON.stringify({until})); }catch(e){}
  }

  let state = load();
  let until = state && state.until > now ? state.until : (now + minutes*60*1000);
  if(key) save(until);

  function tick(){
    const remain = Math.max(0, until - Date.now());
    const m = Math.floor(remain / 60000);
    const s = Math.floor((remain % 60000) / 1000);
    el.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    if(remain <= 0){
      // restart a fresh window
      until = Date.now() + minutes*60*1000;
      if(key) save(until);
    }
  }

  tick();
  setInterval(tick, 1000);
})();
